import React from 'react';
import Confetti from 'react-confetti';
import { useNavigate } from 'react-router-dom';

const SurveyThanks = () => {
  const navigate = useNavigate();

  return (
    <>
      <Confetti width={window.innerWidth} height={window.innerHeight} />
      <div
        style={{
          background: "rgba(255, 255, 255, 0.3)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          borderRadius: "0.5rem",
          padding: "2rem",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          width: "100%",
          maxWidth: "80%",
          margin: "0 auto",
          color: "whitesmoke",
          textAlign: "center",
          marginTop: "30vh",
        }}
      >
        <p style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "1rem" }}>Thank you for joining us!</p>
        <p style={{ fontSize: "1.2rem", marginBottom: "2rem" }}>We're excited to have you here! Your registration has been received.</p>
        
        <div className="flex flex-col gap-4 justify-center items-center mt-6">
            <button 
                onClick={() => navigate('/academy/dashboard')}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg transition-all"
            >
                Go to Training Dashboard
            </button>
            
            <button 
                onClick={() => navigate('/')}
                className="text-white underline text-sm hover:text-blue-200"
            >
                Back to Home
            </button>
        </div>
      </div>
    </>
  );
};

export default SurveyThanks;